import { Input, Output, EventEmitter } from '@angular/core';
import { Getter } from './interfaces';
import { EventBinderService } from '../shared/event-binder.service';

export const OverlayOptions = ['cursor', 'extData', 'bubble', 'clickable', 'draggable'];

export class AMapOverlay<T extends AMap.EventEmitter> {
  // ---- Options ----
  /**
   * é¼ æ æ¬åæ¶çé¼ æ æ ·å¼
   */
  @Input() cursor: string;
  /**
   * èªå®ä¹æ°æ®
   */
  @Input() extData: any;
  /**
   * äºä»¶æ¯å¦ç©¿éå°å°å¾
   */
  @Input() bubble: boolean;
  /**
   * æ¯å¦æ¯æç¹å»
   */
  @Input() clickable: boolean;
  /**
   * æ¯å¦æ¯æææ½
   */
  @Input() draggable: boolean;

  // ---- Events ----
  @Output() naTouchStart: EventEmitter<any>;
  @Output() naTouchMove: EventEmitter<any>;
  @Output() naTouchEnd: EventEmitter<any>;
  @Output() naClick: EventEmitter<any>;
  @Output() naDblClick: EventEmitter<any>;
  @Output() naRightClick: EventEmitter<any>;
  @Output() naMouseOver: EventEmitter<any>;
  @Output() naMouseUp: EventEmitter<any>;
  @Output() naMouseOut: EventEmitter<any>;
  @Output() naMouseDown: EventEmitter<any>;

  constructor(protected os: Getter<T>, protected binder: EventBinderService) {
    const target = os.get();
    this.naTouchStart = this.binder.bindEvent(target, 'touchstart');
    this.naTouchMove = this.binder.bindEvent(target, 'touchmove');
    this.naTouchEnd = this.binder.bindEvent(target, 'touchend');
    this.naClick = this.binder.bindEvent(target, 'click');
    this.naDblClick = this.binder.bindEvent(target, 'dblclick');
    this.naRightClick = this.binder.bindEvent(target, 'rightclick');
    this.naMouseOver = this.binder.bindEvent(target, 'mouseover');
    this.naMouseUp = this.binder.bindEvent(target, 'mouseup');
    this.naMouseOut = this.binder.bindEvent(target, 'mouseout');
    this.naMouseDown = this.binder.bindEvent(target, 'mousedown');
  }
}
